import { type AudioLevelsMap } from './audioLevels';

/**
 * If the audio level is less than our speech threshold, then coalesce it to 0 (silence).
 * @see https://tokbox.com/developer/guides/customize-ui/js#audio_levels
 * Scale: 0 to 100.
 */
const SPEECH_VOLUME_THRESHOLD = 20;

type Speaker = [string, number];

const byAudioLevel = ([, a]: Speaker, [, b]: Speaker): number => b - a;

export const detectLoudestSpeaker = (
  audioLevelsMap: AudioLevelsMap,
): string | undefined => {
  return [...audioLevelsMap.entries()]
    .sort(byAudioLevel)
    .filter(([, level]) => level >= SPEECH_VOLUME_THRESHOLD)
    .map(([id]) => id)
    .at(0);
};

export const someoneIsSpeaking = (
  speaker: string | undefined,
): speaker is string => speaker !== undefined;
